import storage from '../../utils/storage'

const STORAGE_KEY = 'tr_v3_cases_real'
const STORAGE_COURSES = 'tr_v3_courses_real'

export default {
  state: {
    cases: [],
    courses: []
  },
  mutations: {
    SET_CASES(state, list) {
      state.cases = list
      storage.set(STORAGE_KEY, list)
    },
    ADD_CASE(state, c) {
      state.cases.push(c)
      storage.set(STORAGE_KEY, state.cases)
    },
    UPDATE_CASE(state, c) {
      const idx = state.cases.findIndex(x => x.case_id === c.case_id)
      if (idx >= 0) {
        state.cases.splice(idx, 1, c)
        storage.set(STORAGE_KEY, state.cases)
      }
    },
    DELETE_CASE(state, id) {
      state.cases = state.cases.filter(x => x.case_id !== id)
      storage.set(STORAGE_KEY, state.cases)
    },
    SET_COURSES(state, list) {
      state.courses = list
      storage.set(STORAGE_COURSES, list)
    },
    ADD_COURSE(state, c) {
      state.courses.push(c)
      storage.set(STORAGE_COURSES, state.courses)
    },
    UPDATE_COURSE(state, c) {
      const idx = state.courses.findIndex(x => x.course_id === c.course_id)
      if (idx >= 0) {
        state.courses.splice(idx, 1, c)
        storage.set(STORAGE_COURSES, state.courses)
      }
    },
    DELETE_COURSE(state, id) {
      state.courses = state.courses.filter(x => x.course_id !== id)
      storage.set(STORAGE_COURSES, state.courses)
    }
  },
  getters: {
    allCases: state => state.cases,
    allCourses: state => state.courses
  }
}
